import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import { Auth } from "../../interface";
import ENDPOINTS from "../../services/endPoints";

interface IProps {
  box_id: string;
  page?: string;
  limit?: string;
  action?: string; // comma-separated action names, e.g. "assigned,unassigned"
  from?: string;   // ISO date or unix seconds
  to?: string;
  sort?: "asc" | "desc";
}

export const useGetBoxAuditLogs = ({
  box_id,
  page = "1",
  limit = "20",
  action,
  from,
  to,
  sort = "desc",
}: IProps): QueryReturnType<any> => {
  return useQuery<Auth, never, any>(
    [ENDPOINTS.GET_BOX_AUDIT_LOGS, { box_id, page, limit, action, from, to, sort }],
    {
      enabled: !!box_id,
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 0,
      cacheTime: 0,
      notifyOnChangeProps: ["data", "error", "refetch", "isRefetching", "isSuccess", "isLoading"],
    }
  );
};
